import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useNavigate } from "react-router-dom"
import {
    Card,
    CardBody,
    Modal,
    ModalHeader,
    ModalBody,
} from "reactstrap"
import DeleteModel from "common/deleteModel/deleteModel"
import { dateFormat } from "pages/Common"
import toast from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import ErrorModel from "common/errorModel/errorModel"
import breadcrumbs from "../../../common/Breadcrumbs"
import { useLocation } from "react-router-dom"
import { routes } from "routes/path"
import SalesTable from "./SalesTable"
import SaleProductsModel from "./SaleProductsModel"
import TransactionSettleModel from "./TransactionSettleModel"
import TransactionModel from "./TransactionModel"
import { exportSalesDataExcel } from "pages/ExportData"

function SalesList
    () {
    let { pathname } = useLocation()
    const { deleteApi, postApi, getApi } = useApi()
    document.title = `Sales
   | ${localStorage.getItem("ShopName")}`
    const navigate = useNavigate()

    // useStates
    const [tableData, setTableData] = useState([])
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const [isLoading, setIsLoading] = useState(false)
    const [searchText, setSearchText] = useState("")
    const [displayStart, setDisplayStart] = useState(1)
    const [TotalRecords, setTotalRecords] = useState(0)
    const [isMobile, setisMobile] = useState(window.innerWidth < 768)
    const [dateDisble, setdateDisble] = useState(false)
    const [date, setdate] = useState([new Date(), new Date()])
    const [transactionModelFlag, setTransactionModelFlag] = useState(false)
    const [transactionSettleModelFlag, setTransactionSettleModelFlag] = useState(false)
    const [billNo, setBillNo] = useState()
    const [saleId, setSaleId] = useState(0)
    const [saleDetails, setSaleDetails] = useState()
    const [pendingBills, setPendingBills] = useState(false)

    // pagination
    const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
        setRowsPerPage(pageSize)
        setSearchText(serchValue == undefined ? "" : serchValue)
        setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
    }

    const salesProductList = () => {
        setIsLoading(true)
        postApi("Sales/list", {
            fromDate: !dateDisble
                ? null
                : date[0]
                    ? dateFormat(date[0], "yyyy-MM-dd")
                    : new Date().toISOString().slice(0, 10),
            toDate: !dateDisble
                ? null
                : date[1]
                    ? dateFormat(date[1], "yyyy-MM-dd")
                    : new Date().toISOString().slice(0, 10),
            pendingBills: pendingBills,
            displayStart: displayStart,
            pageSize: rowsPerPage,
            searchText: searchText.trim(),
            sortColumn: "",
            sortOrder: "",
        }).then(({ data, status }) => {
            if (status === 200) {
                setTableData(data.Saleslist)
                setTotalRecords(data.TotalRecords)
                setIsLoading(false)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
                setIsLoading(false)
            }
        })
    }

    useEffect(() => {
        if (date[1] != undefined) {
            salesProductList()
        }
    }, [dateDisble, date, rowsPerPage, searchText, displayStart, pendingBills])

    // product delete handler
    const handleDelete = productSaleId => {
        setIsLoading(true)
        if (productSaleId) {
            DeleteModel.confirmDeleteInquiry({
                title: "Are you sure? ",
                text: "You want to delete this sale item permanently? ",
                isMobile,
            }).then(response => {
                if (response == true) {
                    deleteApi(`Sales/delete?id=${parseInt(productSaleId)}`).then(
                        ({ data, status }) => {
                            if (status === 200) {
                                const updatedArray = tableData
                                    .map(obj => (obj.Id !== productSaleId ? obj : null))
                                    .filter(Boolean)
                                setTableData(updatedArray)
                                toast.success("Product sucessfully deleted", {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                            } else {
                                ErrorModel.errormodel({
                                    title: "Verify Product",
                                    text: data,
                                })
                            }
                            setIsLoading(false)
                        }
                    )
                } else {
                    setIsLoading(false)
                }
            })
        }
    }

    const handleEdit = saleId => {
        if (saleId) {
            navigate(routes.updateSale, {
                state: {
                    saleId: saleId,
                },
            })
        }
    }

    const handlePrint = async (id) => {
        setIsLoading(true)
        getApi(`Report/sale-invoice?saleId=${id}`).then(({ data, status }) => {
            const byteCharacters = atob(data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });

            const url = URL.createObjectURL(blob);
            const newWindow = window.open(url);

            newWindow.addEventListener('load', () => {
                newWindow.print();
            });
            setIsLoading(false)
        })
    };

    const columns = useMemo(
        () => [
            {
                Header: "Bill No",
                accessor: "BillNo",
                width: "7%",
            },
            {
                Header: "Date",
                accessor: "Date",
                width: "8%",
                Cell: ({ row }) => (
                    <span>
                        {row.original?.Date.split("T")[0] == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row.original?.Date, "dd/MM/yyyy")}
                    </span>
                ),
            },
            {
                Header: "Name",
                accessor: "Name",
                Cell: ({ row }) => (
                    <span>
                        {row.original.Name ? row.original.Name : "N/A"}
                    </span>
                ),
            },
            {
                Header: "Contact No",
                accessor: "ContactNo",
                width: "8%",
                Cell: ({ row }) => (
                    <span>
                        {row.original.ContactNo ? row.original.ContactNo : "N/A"}
                    </span>
                ),
            },
            {
                Header: "Total Qty",
                accessor: "TotalQty",
                width: "6%",
                Cell: ({ row }) => (
                    <div
                        className="text-center"
                    // onClick={() => {
                    //     handleProductView(row.original.Id)
                    // }}
                    >
                        {row.original?.TotalQty}
                    </div>
                ),
            },
            {
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "end",
                        textAlign: "end"
                    }}
                    >
                        Bill Amt.
                    </div>
                ),
                accessor: "NetAmount",
                width: "7%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}
                        >
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row?.original?.NetAmount || 0)}
                        </div>
                    )
                },
            },
            {
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "end",
                        textAlign: "end"
                    }}
                    >
                        Advance
                    </div>
                ),
                accessor: "Advance",
                width: "7%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}
                        >
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(Math.round(row?.original?.Advance || 0))}
                        </div>
                    )
                },
            },
            {
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "end",
                        textAlign: "end"
                    }}
                    >
                        Discount
                    </div>
                ),
                accessor: "Discount",
                width: "7%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}
                        >
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row?.original?.Discount || 0)}
                        </div>
                    )
                },
            },
            {
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "end",
                        textAlign: "end"
                    }}
                    >
                        GST Amt.
                    </div>
                ),
                accessor: "GSTAmount",
                width: "7%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}
                        >
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row?.original?.GSTAmount || 0)}

                        </div>
                    )
                },
            },
            {
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Action
                    </div>
                ),
                width: "12%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
                            {/* <li className="mytooltip">
                                <i
                                    className="fs-6 fas fa-download "
                                    id={`deletetooltip${row.original.Id}`}
                                    style={{ color: "#f39900" }}
                                    onClick={() => handleDownload(row.original.Id, row.original.BillNo)}
                                ></i>
                                <span className="mytext">Download</span>
                            </li> */}
                            <li className="mytooltip">
                                <i
                                    className="fs-6 fas fa-print "
                                    style={{ color: "#90499c", cursor: "pointer" }}
                                    id={`printtooltip${row.original.Id}`}
                                    onClick={() =>
                                        handlePrint(row.original.Id)}
                                ></i>
                                <span className="mytext">Print</span>
                            </li>
                            <li className="mytooltip">
                                <i
                                    className=" fs-6 fas fa-edit btn-edit "
                                    id={`edittooltip${row.original.Id}`}
                                    onClick={() => handleEdit(row.original.Id)}
                                ></i>
                                <span className="mytext">Edit</span>
                            </li>
                            <li className="mytooltip">
                                <i
                                    className="fas fa-money-bill-alt"
                                    style={{ color: "#556ee6", cursor: "pointer" }}
                                    onClick={() => handleSettleModel(row.original)}
                                ></i>
                                <span className="mytext">Payment</span>
                            </li>
                            <li className="mytooltip">
                                <i
                                    className="fas fa-handshake"
                                    style={{ color: "#90499c", cursor: "pointer" }}
                                    onClick={() => handleTransaction(row.original.Id, row.original.BillNo)}
                                ></i>
                                <span className="mytext">Transaction</span>
                            </li>
                            <li className="mytooltip">
                                <i
                                    className="fs-6 fas fa-trash-alt btn-delete"
                                    id={`deletetooltip${row.original.Id}`}
                                    onClick={() => handleDelete(row.original.Id)}
                                ></i>
                                <span className="mytext">Delete</span>
                            </li>
                        </ul>
                    )
                },
            },
        ],
        [tableData, TotalRecords]
    )
    // redirect create product handler
    const handleUserClicks = () => {
        navigate(routes.createSale)
    }

    const toggleTransaction = () => {
        setTransactionModelFlag(!transactionModelFlag)
    }

    const toggleTransactionSettle = () => {
        setTransactionSettleModelFlag(!transactionSettleModelFlag)
    }

    // view all transaction handler
    const handleTransaction = (SaleId, billNo) => {
        if (SaleId) {
            setBillNo(billNo)
            setSaleId({ ...saleId, saleId: SaleId })
            toggleTransaction()
        }
    }

    const handleSettleModel = (saleDetails) => {
        if (saleDetails.Id) {
            setSaleDetails(saleDetails)
            toggleTransactionSettle()
        }
    }

    function writeDataToExcel() {
        setIsLoading(true)
        let header = ["Bill No.", "Date", "Name", "Contact No.", "Total Qty", "Bill Amt.", "Advance", "Discount", "GST Amt."];
        const mainTitle = "Sales";
        const widthObj = [
            {
                Key: "A",
                Value: 10,
            },
            {
                Key: "B",
                Value: 15,
            },
            {
                Key: "C",
                Value: 25,
            },
            {
                Key: "D",
                Value: 15,
            },
            {
                Key: "E",
                Value: 10,
            },
            {
                Key: "F",
                Value: 10,
            },
            {
                Key: "G",
                Value: 10,
            },
            {
                Key: "H",
                Value: 10,
            },
            {
                Key: "I",
                Value: 12,
            },
            {
                Key: "J",
                Value: 12,
            },
        ]

        const extention = "Sales.xlsx"
        postApi("Sales/list", {
            fromDate: !dateDisble
                ? null
                : date[0]
                    ? dateFormat(date[0], "yyyy-MM-dd")
                    : new Date().toISOString().slice(0, 10),
            toDate: !dateDisble
                ? null
                : date[1]
                    ? dateFormat(date[1], "yyyy-MM-dd")
                    : new Date().toISOString().slice(0, 10),
            pendingBills: pendingBills,
            displayStart: 1,
            pageSize: 1000000,
            searchText: searchText.trim(),
            sortColumn: "",
            sortOrder: "",
        }).then(({ data, status }) => {
            if (status === 200) {
                setIsLoading(false)
                // setTotalRecords(data.TotalRecords)
                let excelSheetData = []
                let totalBillAmount = 0
                let totalAdvance = 0
                let totalDiscount = 0
                let totalGSTAmount = 0
                for (let index = 0; index < data.Saleslist.length; index++) {
                    totalBillAmount += parseFloat(data.Saleslist[index].NetAmount)
                    totalAdvance += parseFloat(data.Saleslist[index].Advance)
                    totalDiscount += parseFloat(data.Saleslist[index].Discount)
                    totalGSTAmount += parseFloat(data.Saleslist[index].GSTAmount)
                    let dataObj = {
                        BillNo: data.Saleslist[index].BillNo,
                        Date: dateFormat(data.Saleslist[index].Date.split("T")[0],
                            "dd/MM/yyyy"),
                        Name: data.Saleslist[index].Name,
                        ContactNo: data.Saleslist[index].ContactNo,
                        TotalQty: data.Saleslist[index].TotalQty,
                        BillAmt: data.Saleslist[index].NetAmount,
                        Advance: data.Saleslist[index].Advance || 0,
                        Discount: data.Saleslist[index].Discount || 0,
                        GSTAmt: data.Saleslist[index].GSTAmount || 0,
                    }
                    excelSheetData.push(dataObj)
                }
                var fields = Object.keys(excelSheetData[0]);
                var sheetData = excelSheetData.map(function (row) {
                    return fields.map(function (fieldName) {
                        return row[fieldName];
                    });
                });
                sheetData.unshift(header);
                exportSalesDataExcel(sheetData, mainTitle, widthObj, extention, totalBillAmount, totalAdvance, totalDiscount, totalGSTAmount)

            } else {
                setIsLoading(false)
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })

    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                {isLoading && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].title}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                />
                <Card>
                    <CardBody>
                        <SalesTable
                            columns={columns}
                            data={tableData}
                            isGlobalFilter={true}
                            handleUserClick={handleUserClicks}
                            customPageSize={10}
                            className="custom-header-css"
                            pagePerSize={pagePerSize}
                            isLoading={isLoading}
                            TotalRecords={TotalRecords}
                            dateDisble={dateDisble}
                            setdateDisble={setdateDisble}
                            date={date}
                            setdate={setdate}
                            pendingBills={pendingBills}
                            setPendingBills={setPendingBills}
                            writeDataToExcel={writeDataToExcel}
                        />

                        <TransactionModel
                            modal={transactionModelFlag}
                            toggle={toggleTransaction}
                            saleId={saleId}
                            billNo={billNo}
                        />

                        <TransactionSettleModel
                            modal={transactionSettleModelFlag}
                            toggle={toggleTransactionSettle}
                            saleDetails={saleDetails}
                            salesProductList={salesProductList}
                        />

                    </CardBody>
                </Card>
            </div>
        </div>
    )
}
SalesList
    .propTypes = {
    preGlobalFilteredRows: PropTypes.any,
}

export default SalesList

